$(function () {


  function scroll() {
    
    var ps = new PerfectScrollbar('.js-termsOfService');
    
  }

  const isPageAgreement = $('#agreement').length;
  if (isPageAgreement) {
    scroll();
  }
  
});